import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'

import { FaQrcode } from 'react-icons/fa'

import MuiExpansionPanel from '@material-ui/core/ExpansionPanel'
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Context from '../../context'
import history from '../../services/history'

import { getPartnerById, publishUnit } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import changeLogo from '../../assets/images/altera-logo.png'

import PhoneFormat from '../../components/PhoneFormat'
import ProgressBar from '../../components/ProgressBar'
import QrCodeModal from '../../components/QrCodeModal'
import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'

function UnitiesList({ location }) {
  const { state } = location
  const {
    editPartner,
    setEditUnity,
    setPartnerToEdit,
    setUser,
    setOpenToast,
    setAboutCurrentPage
  } = useContext(Context)
  const [partner, setPartner] = useState(null)
  const [unitiesList, setUnitiesList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [fullUnitiesList, setFullUnitiesList] = useState([])
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [publicLoading, setPublicLoading] = useState({
    loading: false,
    objectId: 0
  })
  const [qrCodeData, setQrCodeData] = useState({
    id: 0,
    name: '',
    slug: '',
    loading: true
  })

  // Collapse
  const [expanded, setExpanded] = useState('panel1')
  const handleChangePanel = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  const ExpansionPanel = withStyles({
    root: {
      border: '1px solid rgba(0, 0, 0, .125)',
      boxShadow: 'none',
      '&:last-child': {
        borderBottom: 1
      },
      '&:before': {
        display: 'none'
      },
      '&$expanded': {
        margin: 'auto'
      }
    },
    expanded: {}
  })(MuiExpansionPanel)

  const ExpansionPanelSummary = withStyles({
    root: {
      backgroundColor: 'rgba(0, 0, 0, .03)',
      borderBottom: '1px solid rgba(0, 0, 0, .125)',
      marginBottom: -1,
      minHeight: 56,
      '&$expanded': {
        minHeight: 56
      }
    },
    content: {
      '&$expanded': {
        margin: '12px 0'
      }
    },
    expanded: {}
  })(MuiExpansionPanelSummary)

  const ExpansionPanelDetails = withStyles(theme => ({
    root: {
      padding: theme.spacing(2)
    }
  }))(MuiExpansionPanelDetails)

  useEffect(() => {
    if (isAuthenticated) {
      let loggedUser = getLoggedUser()
      loggedUser = { ...loggedUser, partnerId: editPartner.id }
      setUser(loggedUser)
      setAboutCurrentPage({
        title: `Parceiro`,
        buttons: [
          {
            title: 'Voltar',
            pathname: '/partnerslist'
          }
        ]
      })
    } else {
      history.replace('/')
    }

    if (state && state.showToast) {
      setOpenToast({
        open: true,
        message: state.toastMessage,
        type: 'success'
      })
    } else {
      setOpenToast({
        open: false,
        message: '',
        type: 'success'
      })
    }
  }, [])

  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)

      const newList = fullUnitiesList.filter(item => {
        return item.fantasyName.toLowerCase().includes(searchData.str.toLowerCase())
      })
      setUnitiesList(newList)
      setIsLoading(false)
    }

    if (!searchData.startSearch && searchData.str === '') {
      setUnitiesList(fullUnitiesList)
    }
  }, [searchData])

  useEffect(() => {
    const getPartner = async () => {
      return getPartnerById(editPartner.id)
    }

    if (editPartner.id !== null) {
      getPartner().then(partnerItem => {
        setPartner(partnerItem)
        setIsLoading(false)
      })
    } else {
      history.replace('/')
    }
  }, [editPartner])

  useEffect(() => {
    if (partner) {
      const { partnerUnits } = partner

      if (partnerUnits) {
        setFullUnitiesList(partnerUnits)
        setUnitiesList(partnerUnits)
      } else {
        setUnitiesList([])
      }
    }
  }, [partner])

  const handleSearch = str => {
    if (str.length >= 3) {
      const newList = fullUnitiesList.filter(item => {
        return item.fantasyName.toLowerCase().includes(str.toLowerCase())
      })
      setUnitiesList(newList)
    }
    if (str.length === 0) {
      setUnitiesList(fullUnitiesList)
    }
  }

  const handleUnityClick = async unityId => {
    setEditUnity({ id: unityId, partnerId: partner.id })

    history.push('/unityform')
  }

  const checkLoading = id => {
    return publicLoading.loading && publicLoading.objectId === id
  }

  const handlePublicClick = unity => {
    setPublicLoading({ loading: true, objectId: unity.id })
    publishUnit(unity.id, unity.situation === 3 ? 1 : 3).then(r => {
      if (r) {
        setUnitiesList(list => {
          return list.map(item => {
            if (item.id === unity.id) {
              const situation = item.situation === 3 ? 1 : 3
              return { ...item, situation }
            }
            return item
          })
        })

        setOpenToast({
          open: true,
          message: 'Unidade atualizada com sucesso',
          type: 'success'
        })

        setPublicLoading({ loading: false, objectId: 0 })
      } else {
        setOpenToast({
          open: true,
          message: 'Ocorreu algum erro ao atualizar.',
          type: 'error'
        })
      }
    })
  }

  return (
    <div className="container-fluid h-100">
      <ToastMessages />
      <Context.Provider
        value={{
          searchData,
          setSearchData,
          editPartner,
          setEditUnity,
          setUser,
          setOpenToast,
          setPartnerToEdit
        }}
      >
        <TopSearch
          buttonLabel="Adicionar Unidade"
          goTo="unityform"
          editPartner
          showEditPartner
          searchAction={handleSearch}
        />
      </Context.Provider>
      {isLoading ? (
        <ProgressBar height="30px" width="100%" marginTop="30px" />
      ) : (
        <>
          {unitiesList.map((unity, index) => (
            <ExpansionPanel
              key={unity.id}
              square
              expanded={expanded === `panel${unity.id}`}
              onChange={handleChangePanel(`panel${unity.id}`)}
            >
              <ExpansionPanelSummary
                aria-controls="panel1d-content"
                expandIcon={<ExpandMoreIcon />}
                id="panel1d-header"
              >
                <Typography>
                  {unity.fantasyName} | {unity.neighborhood}{' '}
                  {unity.situation === 3 && (
                    <small style={{ fontSize: 12, color: 'red' }}>Rascunho</small>
                  )}
                  {unity.situation === 1 && (
                    <small style={{ fontSize: 12, color: 'green' }}>Publicado</small>
                  )}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Typography>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-3">
                        <img
                          src={
                            unity.logo !== ''
                              ? process.env.REACT_APP_IMAGES_URL + unity.logo
                              : changeLogo
                          }
                          alt={`Logo ${unity.fantasyName}`}
                          className="rounded partner-logo "
                        />
                      </div>
                      <div className="col-9">
                        <div className="row">
                          <div className="col-6">
                            <h5>Responsável:</h5>
                            <p>{unity.contactName || ''}</p>
                          </div>
                          <div className="col-6">
                            <h5>Telefone:</h5>
                            <p>
                              <PhoneFormat phone={unity.contactPhone || ''} />
                            </p>
                          </div>
                          <div className="col-12">
                            <h5>Endereço:</h5>
                            <p>
                              {unity.address || ''}, {unity.number || ''}
                            </p>
                          </div>
                          <div className="col-6">
                            <h5>Bairro:</h5>
                            <p>{unity.neighborhood || ''}</p>
                          </div>
                          <div className="col-6">
                            <h5>Cidade:</h5>
                            <p>{unity.city || ''}</p>
                          </div>
                          <div className="col-6 offset-6">
                            {checkLoading(unity.id) ? (
                              <ProgressBar
                                height="20px"
                                marginBottom="15px"
                                marginTop="15px"
                                width="100%"
                              />
                            ) : (
                              <>
                                <button
                                  disabled={checkLoading(unity.id)}
                                  className={`card-link btn ${
                                    unity.situation === 3 ? 'btn-success' : 'btn-danger'
                                  }`}
                                  onClick={() => handlePublicClick(unity)}
                                  type="button"
                                >
                                  {unity.situation === 3 ? 'Publicar' : 'Desativar'}
                                </button>
                                <button
                                  className="btn clube-btn clube-blue "
                                  type="button"
                                  onClick={() => handleUnityClick(unity.id)}
                                >
                                  Editar Unidade
                                </button>
                                <button
                                  className=" btn btn-success "
                                  type="button"
                                  onClick={() =>
                                    setQrCodeData({
                                      id: unity.id,
                                      loading: true,
                                      name: unity.fantasyName,
                                      slug: unity.slug
                                    })
                                  }
                                  data-toggle="modal"
                                  data-target="#qrCodeModal"
                                  style={{ marginLeft: 5 }}
                                >
                                  <FaQrcode />
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Typography>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))}
        </>
      )}
      <Context.Provider value={{ qrCodeData, setQrCodeData }}>
        <QrCodeModal />
      </Context.Provider>
    </div>
  )
}

UnitiesList.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.object
  }).isRequired
}

export default UnitiesList
